import { Component, Input, OnInit } from '@angular/core';
import { LocationListService } from 'src/app/services/location-list.service';

@Component({
  selector: 'app-fuel-tank',
  templateUrl: './fuel-tank.component.html',
  styleUrls: ['./fuel-tank.component.scss']
})
export class FuelTankComponent implements OnInit
{

  @Input() public tankLevel: number;
  @Input() public isLocationWillCall: boolean;
  @Input() public showRadioWaves: boolean;
  @Input() public isOilTank: boolean;
  @Input() public showPercent: boolean = true;
  public roundedTankLevel: number;
  public locationListService: LocationListService;
  private static counter: number = 0;
  public tankId: string = "tanklevelId" + FuelTankComponent.counter++;

  constructor() { }

  ngOnInit(): void
  {
    this.roundedTankLevel = Math.round(this.tankLevel);
    this.tankLevel = 50 - (this.tankLevel * 0.5);
  }

  public updateSlider(value: string)
  {
    this.roundedTankLevel = +value;
    this.tankLevel = 50 - (+value * 0.5);
  }

  public get shouldShowPercent(): boolean
  {
    return !this.isLocationWillCall && this.showPercent;
  }
}
